module.exports = __webpack_public_path__ + "static/LOGO - one2car 1.1cb0259f.svg";